// extracted by css-extract-rspack-plugin
export default {"popup":"popup-1R6c5"};